export function formatMoveOutDate(moveOutDate: string) {
  const date = new Date(moveOutDate);

  return {
    day: date.getDate().toString(),
    month: (date.getMonth() + 1).toString(),
    year: date.getFullYear().toString(),
  };
}
